import React from "react"

export const Facebook = () => {
    return (
        <svg width="29" height="29" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_1_569)">
                <path fillRule="evenodd" clipRule="evenodd" d="M14.1502 0.424805C16.6786 0.453657 18.9628 1.07506 21.0027 2.28902C23.0183 3.47875 24.695 5.16568 25.8724 7.1885C27.079 9.24071 27.6967 11.5387 27.7254 14.0825C27.6538 17.5631 26.556 20.5358 24.4321 23.0007C22.3081 25.4656 19.5879 26.9905 16.7719 27.5751V17.8168H19.4342L20.0363 13.982H16.005V11.4703C15.9826 10.9496 16.1472 10.4381 16.4692 10.0282C16.7916 9.61724 17.3593 9.40124 18.1724 9.38021H20.6067V6.02101C20.5718 6.00978 20.2404 5.96534 19.6124 5.88769C18.9003 5.80437 18.1841 5.75986 17.4671 5.75437C15.8443 5.76186 14.5609 6.21961 13.6169 7.12764C12.6729 8.0354 12.1906 9.34874 12.1702 11.0677V13.982H9.10235V17.8168H12.1702V27.5751C8.71258 26.9905 5.99233 25.4656 3.86841 23.0007C1.74448 20.5358 0.64674 17.563 0.575073 14.0825C0.603747 11.5386 1.2214 9.2406 2.42802 7.1885C3.60546 5.16568 5.28215 3.47875 7.29776 2.28902C9.33763 1.0753 11.6218 0.453891 14.1502 0.424805Z" fill="currentColor" />
            </g>
            <defs>
                <clipPath id="clip0_1_569">
                    <rect width="28.0488" height="28.0488" fill="white" transform="translate(0.170654)" />
                </clipPath>
            </defs>
        </svg>


    )
}